import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 480;
const DEFAULT_HEIGHT = 300;

const DEFAULT_ENABLE_AXIS_LINE = false;
const DEFAULT_SYMBOL_SIZE = 18;
const DEFAULT_RADIUS_SIZE = 4;

const DEFAULT_CHART_DATA = {
  generalOptions: {
    binSize: 10,
    borderColor: '#FFF',
    borderWidth: 1,
    innerSize: 0,
  },
  legend: {
    enabled: true,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    enabled: false,
    style: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  xAxis: {
    gridLineColor: '#4d4d4d',
    title: {
      text: 'Temperature (fahrenheit)',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    enableLine: DEFAULT_ENABLE_AXIS_LINE,
    style: {
      lineColor: '#4d4d4d',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    gridLineColor: '#4d4d4d',
    title: {
      text: 'Sales',
      style: {
        ...DEFAULT_TEXT_STYLE,
        fontWeight: 'bold',
      },
    },
    enableLine: DEFAULT_ENABLE_AXIS_LINE,
    style: {
      lineColor: '#4d4d4d',
      lineWidth: 1,
    },
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  seriesData: extendSeriesData([
    {
      name: 'Temperature',
      data: [53, 54, 56, 58, 60, 62, 63, 63, 64, 65, 65],
    },
    {
      name: 'Sales',
      data: [215, 125, 175, 145, 275, 430, 275, 320, 480, 478, 440],
    },
    {
      name: 'Revenue',
      data: [230, 112, 150, 162, 250, 450, 230, 300, 460, 426, 455],
    },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
};

export {
  DEFAULT_CHART_DATA,
  DEFAULT_ENABLE_AXIS_LINE,
  DEFAULT_HEIGHT,
  DEFAULT_RADIUS_SIZE,
  DEFAULT_SYMBOL_SIZE,
  DEFAULT_WIDTH,
};
